module.exports = __webpack_public_path__ + "img/partner_media.eb6f0335.jpg";